import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import UserLogin from "./userLogin";
import UserTerms from "./userTerms";
import UserRegister from "./userRegister";
import UserSuccess from "./userWelcome";
import UserVideo from "./userVideo";
import UserQuiz from "./userQuiz";
import Dashboard from "./dashboard";
import MissingProfile from "./missingProfile";
import {
  PortalAuthGuard,
  PortalNotFound,
  PortalPublicOnly,
} from "../_shared/routeGuards";

const UserRouter = () => {
  return (
    <Routes>
      <Route
        path="login"
        element={
          <PortalPublicOnly role="user" homePath="/user/dashboard">
            <UserLogin />
          </PortalPublicOnly>
        }
      />
      <Route path="terms-and-conditions" element={<UserTerms />} />
      <Route path="register" element={<UserRegister />} />
      <Route path="welcome" element={<UserSuccess />} />

      <Route element={<PortalAuthGuard loginPath="/user/login" role="user" />}>
        <Route index element={<Navigate to="dashboard" replace />} />
        <Route path="video" element={<UserVideo />} />
        <Route path="missing-profile" element={<MissingProfile />} />
        <Route path="quiz" element={<UserQuiz />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route
          path="*"
          element={<PortalNotFound homePath="/user/dashboard" portalName="user" />}
        />
      </Route>
    </Routes>
  );
};

export default UserRouter;
